module.exports = __webpack_public_path__ + "img/cloud.6d156d74.svg";